import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const STRINGS = {
    it: {
        // Nav
        nav_dashboard: "DASHBOARD", nav_macro: "MACRO", nav_portfolio: "PORTAFOGLIO",
        nav_watchlist: "TRADING APERTI", nav_open_trades: "TRADING APERTI", nav_closed_positions: "POSIZIONI CHIUSE", nav_budget: "BUDGET", nav_opportunities: "OPPORTUNITÀ",
        // Common
        loading: "Caricamento…", search_placeholder: "Cerca simbolo, azienda, crypto…",
        all: "Tutti", recent: "RECENTI", clear: "PULISCI",
        no_results: "Nessun risultato",
        // Dashboard
        dashboard_title_pre: "Mercati", dashboard_title_accent: "globali",
        dashboard_subtitle: "Segnali tecnici real-time su azioni, crypto, materie prime, energia e indici. RSI, Bollinger, MACD, Fibonacci, posizionamento long/short.",
        symbol: "Simbolo", name: "Nome", price: "Prezzo", change_24h: "24h %", trend: "Trend",
        // Portfolio
        portfolio_title_pre: "Il tuo", portfolio_title_accent: "portafoglio",
        current_value: "VALORE ATTUALE", invested: "INVESTITO",
        add_position: "AGGIUNGI POSIZIONE", cancel: "ANNULLA",
        portfolio_chart_title: "EVOLUZIONE VALORE PORTAFOGLIO",
        my_assets: "I tuoi asset",
        no_positions: "Nessun asset nel portafoglio. Clicca \"AGGIUNGI POSIZIONE\" per iniziare.",
        avg_cost: "PREZZO MEDIO",
        quantity: "Quantità", buy_price: "Prezzo Acq.", current_price: "Prezzo Att.",
        currency: "Valuta", buy_date: "Data Acq.", save_position: "SALVA POSIZIONE", saving: "SALVATAGGIO…",
        // Watchlist
        watchlist_title_pre: "La tua", watchlist_title_accent: "watchlist",
        watchlist_empty: "La tua watchlist è vuota",
        // Budget
        budget_title_pre: "Il tuo", budget_title_accent: "budget",
        budget_subtitle: "Tieni traccia di entrate e uscite per categoria. Filtra per mese.",
        add_tx: "AGGIUNGI VOCE", income: "ENTRATE", expenses: "USCITE", balance: "SALDO",
        amount: "Importo", category: "Categoria", date: "Data", note: "Nota",
        save_tx: "SALVA VOCE", no_tx: "Nessuna voce registrata in questo mese.",
        // Chart
        timeframe: "Timeframe", days: "GIORNI", weeks: "SETTIMANE", months: "MESI", quarters: "TRIMESTRI",
        line: "LINEA", candle: "CANDELE", area: "AREA",
        indicators: "Indicatori",
        // Asset detail
        signal: "SEGNALE OPERATIVO", reasons: "MOTIVAZIONI", prob_direction: "PROBABILITÀ DIREZIONE",
        prob_up: "SALITA", prob_down: "DISCESA", advice: "CONSIGLIO",
        asset_sheet: "SCHEDA ASSET", official_site: "Sito ufficiale",
        // Macro
        macro_title_pre: "Ciclo", macro_title_accent: "economico",
        cycle_phase: "FASE DEL CICLO", confidence: "CONFIDENCE", key_drivers: "KEY DRIVERS",
        outlook_3m: "OUTLOOK 3M", macro_snapshot: "MACRO SNAPSHOT",
        best_assets: "ASSET DA PREFERIRE", avoid_assets: "ASSET DA EVITARE",
    },
    en: {
        nav_dashboard: "DASHBOARD", nav_macro: "MACRO", nav_portfolio: "PORTFOLIO",
        nav_watchlist: "OPEN TRADES", nav_open_trades: "OPEN TRADES", nav_closed_positions: "CLOSED POSITIONS", nav_budget: "BUDGET", nav_opportunities: "OPPORTUNITIES",
        loading: "Loading…", search_placeholder: "Search symbol, company, crypto…",
        all: "All", recent: "RECENT", clear: "CLEAR", no_results: "No results",
        dashboard_title_pre: "Global", dashboard_title_accent: "markets",
        dashboard_subtitle: "Real-time technical signals across stocks, crypto, commodities, energy and indices. RSI, Bollinger, MACD, Fibonacci, long/short positioning.",
        symbol: "Symbol", name: "Name", price: "Price", change_24h: "24h %", trend: "Trend",
        portfolio_title_pre: "Your", portfolio_title_accent: "portfolio",
        current_value: "CURRENT VALUE", invested: "INVESTED",
        add_position: "ADD POSITION", cancel: "CANCEL",
        portfolio_chart_title: "PORTFOLIO VALUE EVOLUTION",
        my_assets: "Your assets",
        no_positions: "No assets in portfolio. Click \"ADD POSITION\" to start.",
        avg_cost: "AVG COST",
        quantity: "Quantity", buy_price: "Buy Price", current_price: "Current Price",
        currency: "Currency", buy_date: "Buy Date", save_position: "SAVE POSITION", saving: "SAVING…",
        watchlist_title_pre: "Your", watchlist_title_accent: "watchlist",
        watchlist_empty: "Your watchlist is empty",
        budget_title_pre: "Your", budget_title_accent: "budget",
        budget_subtitle: "Track income and expenses by category. Filter by month.",
        add_tx: "ADD ENTRY", income: "INCOME", expenses: "EXPENSES", balance: "BALANCE",
        amount: "Amount", category: "Category", date: "Date", note: "Note",
        save_tx: "SAVE ENTRY", no_tx: "No entries recorded for this month.",
        timeframe: "Timeframe", days: "DAYS", weeks: "WEEKS", months: "MONTHS", quarters: "QUARTERS",
        line: "LINE", candle: "CANDLES", area: "AREA", indicators: "Indicators",
        signal: "TRADING SIGNAL", reasons: "REASONS", prob_direction: "DIRECTION PROBABILITY",
        prob_up: "UP", prob_down: "DOWN", advice: "ADVICE",
        asset_sheet: "ASSET INFO", official_site: "Official site",
        macro_title_pre: "Economic", macro_title_accent: "cycle",
        cycle_phase: "CYCLE PHASE", confidence: "CONFIDENCE", key_drivers: "KEY DRIVERS",
        outlook_3m: "3M OUTLOOK", macro_snapshot: "MACRO SNAPSHOT",
        best_assets: "BEST ASSETS", avoid_assets: "AVOID ASSETS",
    },
    es: {
        nav_dashboard: "PANEL", nav_macro: "MACRO", nav_portfolio: "CARTERA",
        nav_watchlist: "OPERACIONES ABIERTAS", nav_open_trades: "OPERACIONES ABIERTAS", nav_closed_positions: "POSICIONES CERRADAS", nav_budget: "PRESUPUESTO", nav_opportunities: "OPORTUNIDADES",
        loading: "Cargando…", search_placeholder: "Buscar símbolo, empresa, crypto…",
        all: "Todos", recent: "RECIENTES", clear: "BORRAR", no_results: "Sin resultados",
        dashboard_title_pre: "Mercados", dashboard_title_accent: "globales",
        dashboard_subtitle: "Señales técnicas en tiempo real para acciones, crypto, materias primas, energía e índices.",
        symbol: "Símbolo", name: "Nombre", price: "Precio", change_24h: "24h %", trend: "Tendencia",
        portfolio_title_pre: "Tu", portfolio_title_accent: "cartera",
        current_value: "VALOR ACTUAL", invested: "INVERTIDO",
        add_position: "AÑADIR POSICIÓN", cancel: "CANCELAR",
        portfolio_chart_title: "EVOLUCIÓN DEL VALOR",
        my_assets: "Tus activos",
        no_positions: "Sin activos en cartera. Haz clic en \"AÑADIR POSICIÓN\".",
        avg_cost: "PRECIO MEDIO",
        quantity: "Cantidad", buy_price: "Precio Comp.", current_price: "Precio Act.",
        currency: "Moneda", buy_date: "Fecha", save_position: "GUARDAR", saving: "GUARDANDO…",
        watchlist_title_pre: "Tu", watchlist_title_accent: "watchlist",
        watchlist_empty: "Tu watchlist está vacía",
        budget_title_pre: "Tu", budget_title_accent: "presupuesto",
        budget_subtitle: "Sigue ingresos y gastos por categoría.",
        add_tx: "AÑADIR", income: "INGRESOS", expenses: "GASTOS", balance: "SALDO",
        amount: "Importe", category: "Categoría", date: "Fecha", note: "Nota",
        save_tx: "GUARDAR", no_tx: "Sin entradas en este mes.",
        timeframe: "Timeframe", days: "DÍAS", weeks: "SEMANAS", months: "MESES", quarters: "TRIM.",
        line: "LÍNEA", candle: "VELAS", area: "ÁREA", indicators: "Indicadores",
        signal: "SEÑAL", reasons: "RAZONES", prob_direction: "PROBABILIDAD",
        prob_up: "SUBE", prob_down: "BAJA", advice: "CONSEJO",
        asset_sheet: "FICHA", official_site: "Sitio oficial",
        macro_title_pre: "Ciclo", macro_title_accent: "económico",
        cycle_phase: "FASE", confidence: "CONFIANZA", key_drivers: "FACTORES CLAVE",
        outlook_3m: "PERSPECTIVA 3M", macro_snapshot: "INDICADORES MACRO",
        best_assets: "ACTIVOS PREFERIDOS", avoid_assets: "ACTIVOS A EVITAR",
    },
    de: {
        nav_dashboard: "DASHBOARD", nav_macro: "MAKRO", nav_portfolio: "PORTFOLIO",
        nav_watchlist: "OFFENE TRADES", nav_open_trades: "OFFENE TRADES", nav_closed_positions: "GESCHLOSSENE POSITIONEN", nav_budget: "BUDGET", nav_opportunities: "CHANCEN",
        loading: "Laden…", search_placeholder: "Symbol, Firma, Crypto suchen…",
        all: "Alle", recent: "ZULETZT", clear: "LÖSCHEN", no_results: "Keine Ergebnisse",
        dashboard_title_pre: "Globale", dashboard_title_accent: "Märkte",
        dashboard_subtitle: "Technische Echtzeit-Signale für Aktien, Crypto, Rohstoffe, Energie und Indizes.",
        symbol: "Symbol", name: "Name", price: "Preis", change_24h: "24h %", trend: "Trend",
        portfolio_title_pre: "Dein", portfolio_title_accent: "Portfolio",
        current_value: "AKTUELLER WERT", invested: "INVESTIERT",
        add_position: "POSITION HINZUFÜGEN", cancel: "ABBRECHEN",
        portfolio_chart_title: "PORTFOLIO-WERTENTWICKLUNG",
        my_assets: "Deine Assets",
        no_positions: "Keine Assets im Portfolio. \"POSITION HINZUFÜGEN\" klicken.",
        avg_cost: "DURCHSCHN. KAUFPREIS",
        quantity: "Menge", buy_price: "Kaufpreis", current_price: "Akt. Preis",
        currency: "Währung", buy_date: "Kaufdatum", save_position: "SPEICHERN", saving: "SPEICHERN…",
        watchlist_title_pre: "Deine", watchlist_title_accent: "Watchlist",
        watchlist_empty: "Deine Watchlist ist leer",
        budget_title_pre: "Dein", budget_title_accent: "Budget",
        budget_subtitle: "Einnahmen und Ausgaben nach Kategorie verfolgen.",
        add_tx: "EINTRAG HINZUFÜGEN", income: "EINNAHMEN", expenses: "AUSGABEN", balance: "SALDO",
        amount: "Betrag", category: "Kategorie", date: "Datum", note: "Notiz",
        save_tx: "SPEICHERN", no_tx: "Keine Einträge in diesem Monat.",
        timeframe: "Zeitrahmen", days: "TAGE", weeks: "WOCHEN", months: "MONATE", quarters: "QUARTALE",
        line: "LINIE", candle: "KERZEN", area: "FLÄCHE", indicators: "Indikatoren",
        signal: "HANDELSSIGNAL", reasons: "GRÜNDE", prob_direction: "RICHTUNGS-WAHRSCHEINLICHKEIT",
        prob_up: "AUFWÄRTS", prob_down: "ABWÄRTS", advice: "EMPFEHLUNG",
        asset_sheet: "ASSET-INFO", official_site: "Offizielle Seite",
        macro_title_pre: "Wirtschafts-", macro_title_accent: "zyklus",
        cycle_phase: "ZYKLUSPHASE", confidence: "KONFIDENZ", key_drivers: "HAUPTFAKTOREN",
        outlook_3m: "3M-AUSBLICK", macro_snapshot: "MAKRO-ÜBERSICHT",
        best_assets: "BEVORZUGTE ASSETS", avoid_assets: "ZU MEIDENDE ASSETS",
    },
    da: {
        nav_dashboard: "OVERSIGT", nav_macro: "MAKRO", nav_portfolio: "PORTEFØLJE",
        nav_watchlist: "ÅBNE HANDLER", nav_open_trades: "ÅBNE HANDLER", nav_closed_positions: "LUKKEDE POSITIONER", nav_budget: "BUDGET", nav_opportunities: "MULIGHEDER",
        loading: "Indlæser…", search_placeholder: "Søg symbol, firma, crypto…",
        all: "Alle", recent: "SENESTE", clear: "RYD", no_results: "Ingen resultater",
        dashboard_title_pre: "Globale", dashboard_title_accent: "markeder",
        dashboard_subtitle: "Realtids tekniske signaler for aktier, crypto, råvarer, energi og indeks.",
        symbol: "Symbol", name: "Navn", price: "Pris", change_24h: "24t %", trend: "Trend",
        portfolio_title_pre: "Din", portfolio_title_accent: "portefølje",
        current_value: "AKTUEL VÆRDI", invested: "INVESTERET",
        add_position: "TILFØJ POSITION", cancel: "ANNULLER",
        portfolio_chart_title: "PORTEFØLJE VÆRDIUDVIKLING",
        my_assets: "Dine aktiver",
        no_positions: "Ingen aktiver i porteføljen. Klik \"TILFØJ POSITION\".",
        avg_cost: "GNS. KØBSPRIS",
        quantity: "Antal", buy_price: "Købspris", current_price: "Akt. pris",
        currency: "Valuta", buy_date: "Købsdato", save_position: "GEM", saving: "GEMMER…",
        watchlist_title_pre: "Din", watchlist_title_accent: "watchlist",
        watchlist_empty: "Din watchlist er tom",
        budget_title_pre: "Dit", budget_title_accent: "budget",
        budget_subtitle: "Følg indtægter og udgifter per kategori.",
        add_tx: "TILFØJ POST", income: "INDTÆGT", expenses: "UDGIFTER", balance: "SALDO",
        amount: "Beløb", category: "Kategori", date: "Dato", note: "Note",
        save_tx: "GEM POST", no_tx: "Ingen poster registreret i denne måned.",
        timeframe: "Tidsramme", days: "DAGE", weeks: "UGER", months: "MÅNEDER", quarters: "KVARTALER",
        line: "LINJE", candle: "STEARINLYS", area: "OMRÅDE", indicators: "Indikatorer",
        signal: "HANDELSSIGNAL", reasons: "GRUNDE", prob_direction: "RETNINGSSANDSYNLIGHED",
        prob_up: "OP", prob_down: "NED", advice: "RÅD",
        asset_sheet: "AKTIVOPLYSNINGER", official_site: "Officiel side",
        macro_title_pre: "Økonomisk", macro_title_accent: "cyklus",
        cycle_phase: "CYKLUSFASE", confidence: "TILLID", key_drivers: "NØGLEFAKTORER",
        outlook_3m: "3M UDSIGT", macro_snapshot: "MAKRO OVERSIGT",
        best_assets: "FORETRUKNE AKTIVER", avoid_assets: "AKTIVER AT UNDGÅ",
    },
};

const LANGUAGES = {
    it: { code: "it", flag: "🇮🇹", label: "Italiano" },
    en: { code: "en", flag: "🇬🇧", label: "English" },
    es: { code: "es", flag: "🇪🇸", label: "Español" },
    de: { code: "de", flag: "🇩🇪", label: "Deutsch" },
    da: { code: "da", flag: "🇩🇰", label: "Dansk" },
};

const STORAGE = "aurum_lang";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        const saved = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE) : null;
        return LANGUAGES[saved] ? saved : "it";
    });

    const setLang = useCallback((l) => {
        if (LANGUAGES[l]) {
            setLangState(l);
            window.localStorage.setItem(STORAGE, l);
        }
    }, []);

    const t = useCallback((key) => (STRINGS[lang] || STRINGS.it)[key] || STRINGS.it[key] || key, [lang]);

    const value = useMemo(() => ({ lang, setLang, t, languages: LANGUAGES }), [lang, setLang, t]);

    return (
        <I18nContext.Provider value={value}>
            {children}
        </I18nContext.Provider>
    );
};

export const useI18n = () => {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
    return ctx;
};
